import React, { useState, useMemo, useEffect } from "react";
import {
  Box, IconButton, Tooltip, Card, CardContent, Grid, Divider, Radio,
  RadioGroup,
  FormControl,
  FormControlLabel, Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Table, TableHead,
  TableBody,
  TableCell,
  TableContainer,
  TableRow, Typography, Paper
} from "@mui/material";
import { useData } from '../../../context/DataContext';
import SingleSelectComponent from "../../../components/Selections/SingleSelectComponent"
import MaterialReactTableWithSearch from "../../../components/MaterialReactTable/MaterialReactTableWithSearch";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { deleteFieldBook } from "../../../context/createAPI";
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from "../../../config/appRoutes";
import MultiSelectComponent from "../../../components/Selections/MultiSelectComponent"
import cottonData from '../Cotton.json'
import { MultiSelect } from "react-multi-select-component";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import UpdateIcon from '@mui/icons-material/Update';
import SingleSelect from "../../../components/Selections/singleSelect";
import MultiSelectWithAll from "../../../components/Selections/multiSelectWithAll";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { getClientTheme } from "../../../theme/clientTheme";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});



const FieldBookHistory = () => {
  const { years = [], farmers = [], user = [], getFieldBooks = [], handleFieldBooks, villageGroups, user_client_id } = useData()
  const levelOptions = [{ value: 1, label: "Groups" }, ...user_client_id === 2 ? [] : [{ value: 2, label: "Villages" }]]
  const navigate = useNavigate();
  const rowActions = (user.user_level_id !== 1 && user.user_level_id !== 2 && user.user_level_id !== 3) ? true : false;
  const clientTheme = getClientTheme(user_client_id);
  const ffGroupData = villageGroups?.filter((item) => item.level_id === 4);
  const groupData = ffGroupData[0]?.data.filter(item => item.group_id !== "").map((item) => ({ value: item.group_id, label: item.Groups }));
  const villageData = ffGroupData[0]?.data.filter((item) => item.village_id !== "").map((item) => ({ value: item.village_id, label: item.village }));
  const [enableSelectAll] = useState(true);
  const defaultWorkNames = ["Gap Filling", "Weeding", "Herbicide"];
  const getDefaultRows7th = () =>
    Array.from({ length: defaultWorkNames.length }, (_, i) => ({
      id: (i + 1).toString(),
      workDetails: defaultWorkNames[i],
      name: "", // ✅ one name per row
      quantity: '',
      noOfLabours: '',
      labourCost: "",
      totalLabourChargesInGapFilling: '',
      total_cost: '',
      estatus: 1,
    }));

  const [state, setState] = useState({
    year: +years[0].value ?? 1,
    selectedFarmers: [],
    getFilterData: getFieldBooks,
    selected_group_ids: [],
    selected_village_ids: [],
    selectedLevel: 1,
    farmerFilterData: [],
    formViewDetails: false,
    formRowData: [],

    selectYear: "",
    farmer: "",
    land_details_arr: [{ soil_type: "", soil_test: "", total_land: "", BCI_land: "" }],
    water_manage_arr: [{ irrigation_facility: "", source_irrigation: "", irrigating_hr: "", irrigation_cm: "", labour_cost: "", fuel_cost: "", ele_cost: "", total_cost: "" }],
    crop_details_arr: [{ inter_crop: "", ratio_inter_crop: "", seed_cost: "", labour_cost: "", other_cost: "", total_cost: "" }],
    form_option_5th_rows: [{ id: "1", type_work: "", equpment_cost: "", fuel_ltrs: "", fuel_cost: "", labour_cost: "", total_cost: "", estatus: 1 }],
    form_option_6th_rows: [{ id: "1", types: '', variety: "", noOfpackets: '', seedPrice: '', labourCost: '', total_cost: '', estatus: 1 }],
    form_option_7th_rows: getDefaultRows7th(),
    form_option_8th_rows: [{ id: "1", typeOf: '', quantity: '', fertilizerCost: '', labourCost: '', totalLabourChargesInOrganicInfo: "", total_cost: '', estatus: 1 }],
    form_option_9th_rows: [{ id: "1", pesticide_name: '', quantity: '', costOfPesticide: '', labourCost: '', total_cost: '', estatus: 1 }],
    form_option_10th_rows: [{ id: "1", practices: '', quantity: '', cost: '', total_cost: '', estatus: 1 }],
    form_option_11th_rows: [{ id: "1", labour_count: '', labour_rate: '', yield: '', cotton_colour_bags: '', greeding_segrigation: '', total_cost: '', estatus: 1 }],
    form_option_12th_rows: [{ id: "1", date: '', sold_cotton: '', ginner: '', cotton_quantity: '', rate: '', income_cotton: '', transport_cost: '', other_cost: '', estatus: 1, total_cost: '' }],
    form_option_13th_rows: [{ usingHHP: '', HHP_name: '', HHP_quantity: '', usingCocktails: '', cocktailsName: '', cock_quantity: '', hhp_cost: "", cocktailsCost: "", total_cost: "", awareness_PAN_Group: "" }],
    form_option_14th_rows: [{ preparation_fuel_liters: '', preparation_fuel_cost: '', total_preparation_fuel_cost: '', transportation_fuel_liters: '', transportation_fuel_cost: '', total_transportation_fuel_cost: '', operations_fuel_liters: '', operations_fuel_cost: '', total_operations_fuel_cost: '', overallLiters: '', finalCost: '', estatus: 1 }],
    safety_precautions_arr: [],
    cotton_income_details_arr: [
      { id: 'A', label: 'Income from Cotton', value: '' },
      { id: 'B', label: 'OTHER INCOME', value: '' },
      { id: 'C', label: 'TOTAL INCOME (A+B)', value: '' },
      { id: 'D', label: 'TOTAL EXPENDETURE', value: '' },
      { id: 'E', label: 'NET PROFIT (C - D)', value: '' }
    ],

    awareness_childlabour_details_arr: [
      { id: 1, name: 'Labour Rights', value: '' },
      { id: 2, name: 'Eradication of Child Labour', value: '' },
      { id: 3, name: 'Minimum Wages', value: '' },
      { id: 4, name: 'Eradication of Gender Discrimination and sexual Harassment', value: '' },
      { id: 5, name: 'Equal Pay for equal Work', value: '' },
      { id: 6, name: 'Providing Minimum Facilities to labours', value: '' },
      { id: 7, name: 'Occupation Safety and Health Care', value: '' },
      { id: 8, name: 'Eradication of Forced labour and Compulsory Labour', value: '' },
      { id: 9, name: 'Formation of Gender committee', value: '' },
    ],

  })


  useEffect(() => {
    if (state.formRowData) {

      setState((prevState) => {
        // Helper function to parse JSON safely
        const parseJSON = (data) => {
          try {
            return data || [];
          } catch (error) {
            console.error("Invalid JSON:", data);
            return [];
          }
        };

        return {
          ...prevState,
          selectYear: state.formRowData.year,
          farmer: state.formRowData.farmer_name,
          land_details_arr: parseJSON(state.formRowData.land_details).map((item) => ({
            soil_type: item.soil_type || "",
            soil_test: item.soil_test || false,
            total_land: item.total_land || "",
            BCI_land: item.BCI_land || "",
          })),
          water_manage_arr: parseJSON(state.formRowData.water_source).map((item) => ({
            irrigation_facility: item.irrigation_facility,
            source_irrigation: item.source_irrigation,
            irrigating_hr: item.irrigating_hr,
            irrigation_cm: item.irrigation_cm,
            labour_cost: item.labour_cost,
            fuel_cost: item.fuel_cost,
            ele_cost: item.ele_cost,
            total_cost: item.total_cost,
          })),
          crop_details_arr: parseJSON(state.formRowData.intercrop).map((item) => ({
            inter_crop: item.inter_crop,
            ratio_inter_crop: item.ratio_inter_crop,
            seed_cost: item.seed_cost,
            labour_cost: item.labour_cost,
            other_cost: item.other_cost,
            total_cost: item.total_cost,
          })),
          form_option_5th_rows: parseJSON(state.formRowData.land_preparation).map((item) => ({
            id: item.id,
            type_work: item.type_work,
            equpment_cost: item.equpment_cost,
            fuel_ltrs: item.fuel_ltrs,
            fuel_cost: item.fuel_cost,
            labour_cost: item.labour_cost,
            total_cost: item.total_cost,
            estatus: item.estatus,
          })),
          form_option_6th_rows: parseJSON(state.formRowData.cotton_crop_details).map((item) => ({
            id: item.id,
            types: item.types,
            variety: item.variety,
            noOfpackets: item.noOfpackets,
            seedPrice: item.seedPrice,
            labourCost: item.labourCost,
            total_cost: item.total_cost,
            totalSeedCost: item.totalSeedCost,
            estatus: item.estatus,
          })),
          form_option_7th_rows: parseJSON(state.formRowData.weeds).map((item) => ({
            id: item.id,
            workDetails: item.workDetails,
            name: item.name,
            quantity: item.quantity,
            noOfLabours: item.noOfLabours,
            total_cost: item.total_cost,
            estatus: item.estatus,
            labourCost: item.labourCost,
            totalLabourChargesInGapFilling: item.totalLabourChargesInGapFilling,
          })),
          form_option_8th_rows: parseJSON(state.formRowData.organic_fertilizers).map((item) => ({
            id: item.id,
            typeOf: item.typeOf,
            quantity: item.quantity,
            fertilizerCost: item.fertilizerCost,
            labourCost: item.labourCost,
            total_cost: item.total_cost,
            totalLabourChargesInOrganicInfo: item.totalLabourChargesInOrganicInfo,
            estatus: item.estatus
          })),
          form_option_13th_rows: parseJSON(state.formRowData.hhp_coktails).map((item) => ({
            usingHHP: item.usingHHP,
            HHP_name: item.HHP_name,
            HHP_quantity: item.HHP_quantity,
            usingCocktails: item.usingCocktails,
            cocktailsName: item.cocktailsName,
            cock_quantity: item.cock_quantity,
            awareness_PAN_Group: item.awareness_PAN_Group,
            hhp_cost: item.hhp_cost, cocktailsCost: item.cocktailsCost, total_cost: item.total_cost,
          })),
          form_option_9th_rows: parseJSON(state.formRowData.pesticides_info).map((item) => ({
            id: item.id,
            pesticide_name: item.pesticide_name,
            quantity: item.quantity,
            costOfPesticide: item.costOfPesticide,
            labourCost: item.labourCost,
            total_cost: item.total_cost,
            estatus: item.estatus,
          })),
          form_option_10th_rows: parseJSON(state.formRowData.best_ownership_practices).map((item) => ({
            id: item.id,
            practices: item.practices,
            quantity: item.quantity,
            cost: item.cost,
            total_cost: item.total_cost,
            estatus: item.estatus,
          })),
          safety_precautions_arr: parseJSON(state.formRowData.safety_precautions),
          form_option_11th_rows: parseJSON(state.formRowData.cotton_picking).map((item) => ({
            id: item.id,
            labour_count: item.labour_count,
            labour_rate: item.labour_rate,
            yield: item.yield,
            cotton_colour_bags: item.cotton_colour_bags,
            greeding_segrigation: item.greeding_segrigation,
            total_cost: item.total_cost,
            estatus: item.estatus,
          })),
          form_option_12th_rows: parseJSON(state.formRowData.cotton_sales).map((item) => ({
            id: item.id,
            date: item.date,
            sold_cotton: item.sold_cotton,
            ginner: item.ginner,
            cotton_quantity: item.cotton_quantity,
            rate: item.rate,
            income_cotton: item.income_cotton,
            transport_cost: item.transport_cost,
            other_cost: item.other_cost,
            total_cost: item.total_cost,
            estatus: item.estatus,
          })),
          form_option_14th_rows: parseJSON(state.formRowData.fuel_costs).map((item) => ({
            preparation_fuel_liters: item.preparation_fuel_liters,
            preparation_fuel_cost: item.preparation_fuel_cost,
            total_preparation_fuel_cost: item.total_preparation_fuel_cost,
            transportation_fuel_liters: item.transportation_fuel_liters,
            transportation_fuel_cost: item.transportation_fuel_cost,
            total_transportation_fuel_cost: item.total_transportation_fuel_cost,
            operations_fuel_liters: item.operations_fuel_liters,
            operations_fuel_cost: item.operations_fuel_cost,
            total_operations_fuel_cost: item.total_operations_fuel_cost,
            overallLiters: item.overallLiters,
            finalCost: item.finalCost,
            estatus: item.estatus,
          })),
          cotton_income_details_arr: parseJSON(state.formRowData.cotton_income).length > 0
            ? parseJSON(state.formRowData.cotton_income).map((item) => ({
              id: item.id || '',
              label: item.label || '',
              value: item.value || '',
            }))
            : [
              { id: 'A', label: 'Income from Cotton', value: '' },
              { id: 'B', label: 'OTHER INCOME', value: '' },
              { id: 'C', label: 'TOTAL INCOME (A+B)', value: '' },
              { id: 'D', label: 'TOTAL EXPENDITURE', value: '' },
              { id: 'E', label: 'NET PROFIT (C - D)', value: '' },
            ],
          awareness_childlabour_details_arr: parseJSON(state.formRowData.awareness_childlabour).length > 0
            ? parseJSON(state.formRowData.awareness_childlabour).map((item) => ({
              id: item.id || '',
              name: item.name || '',
              value: item.value || '',
            }))
            : [
              { id: 1, name: 'Labour Rights', value: '' },
              { id: 2, name: 'Eradication of Child Labour', value: '' },
              { id: 3, name: 'Minimum Wages', value: '' },
              { id: 4, name: 'Eradication of Gender Discrimination and sexual Harassment', value: '' },
              { id: 5, name: 'Equal Pay for equal Work', value: '' },
              { id: 6, name: 'Providing Minimum Facilities to labours', value: '' },
              { id: 7, name: 'Occupation Safety and Health Care', value: '' },
              { id: 8, name: 'Eradication of Forced labour and Compulsory Labour', value: '' },
              { id: 9, name: 'Formation of Gender committee', value: '' },
            ],
        };
      });
    }
  }, [state.formRowData]);

  useEffect(() => {
    const filtered = getFieldBooks?.filter((book) => {
      const matchesFarmer = state.selectedFarmers ? state.selectedFarmers?.some(f => f.value === book.farmer_id) : true;
      const matchesYear = state.year ? book.crop_year_id === parseInt(state.year) : true;
      return matchesFarmer && matchesYear;
    });
    setState(prevState => ({ ...prevState, getFilterData: filtered }));
  }, [state.selectedFarmers, state.year, getFieldBooks]);

  useEffect(() => {
    let filteredFarmersBasedOnSelected = [];
    if (state.selected_group_ids?.length > 0) {
      filteredFarmersBasedOnSelected = farmers?.filter(farmer =>
        state.selected_group_ids.some(selected => parseInt(selected.value) === farmer.ff_group_id)
      );
    } else if (state.selected_village_ids?.length > 0) {
      filteredFarmersBasedOnSelected = farmers?.filter(farmer =>
        state.selected_village_ids.some(selected => parseInt(selected.value) === farmer.village_id)
      );
    }

    setState(prevState => ({
      ...prevState,
      farmerFilterData: filteredFarmersBasedOnSelected,
      selectedFarmers: filteredFarmersBasedOnSelected?.map(farmer => ({
        value: farmer.id,
        label: `${farmer.farmer_name} (${farmer.relative_name})`
      }))
    }));
  }, [state.selected_group_ids, state.selected_village_ids, farmers]);

  const handleInputChange = (name, value) => {
    setState(prevState => ({ ...prevState, [name]: value }));
  };

  const fieldBookColumns = useMemo(
    () => [
      {
        accessorFn: (row, index) => index + 1,
        header: 'SNO',
        id: 'id',
        enableGlobalFilter: false,
      },
      {
        // accessorKey: "farmer_name",
        header: "Farmer Name",
        accessorFn: (row, index) => `${row.farmer_name} (${row.relative_name})`,
      },
      {
        accessorKey: "year",
        header: "Year"
      },
    ], []
  );

  const handleDelete = async (row) => {
    const confirmed = window.confirm(`Are You Sure You Want to Delete ${row.original.farmer_name}?`);
    if (!confirmed) {
      return;
    }

    try {
      const deleteApi = await deleteFieldBook({
        id: row.original.id,
        updated_by: user.user_id
      });
      if (deleteApi.statusCode === 200) {
        handleFieldBooks();
      }
    } catch (error) {
      console.error(error);
    }
  }

  const handleEdit = (row) => {
    const rowData = row.original
    navigate(`${APP_ROUTES.FIELDBOOK.HISTORY_ROUTES.EDIT}`, { state: { rowData } });
  }

  const renderRowActions = ({ row }) => (
    <Box sx={{ display: "flex", gap: "1rem" }}>
      <Tooltip title="View Details">
        <IconButton>
          <VisibilityOutlinedIcon sx={{ color: "var(--secondary)" }} onClick={() => handleView(row)} />
        </IconButton>
      </Tooltip>

      <Tooltip title="Edit">
        <IconButton >
          <UpdateIcon sx={{ color: "var(--success)" }} onClick={() => handleEdit(row)} />
        </IconButton>
      </Tooltip>

      <Tooltip title="Delete">
        <IconButton color="error">
          <DeleteOutlineIcon onClick={() => handleDelete(row)} />
        </IconButton>
      </Tooltip>
    </Box>
  );

  useEffect(() => {
    if (user.user_level_id !== 1 && user.user_level_id !== 2) {
      setState(prevState => ({ ...prevState, selected_village_ids: villageData, selected_group_ids: groupData }));
    } else {
      setState(prevState => ({ ...prevState, selected_group_ids: state.selectedLevel === 1 ? groupData : [], selected_village_ids: state.selectedLevel === 2 ? villageData : [] }));
    }
  }, []);

  const handleMultiselectVillagechange = (selectedOption) => {
    if (enableSelectAll && selectedOption?.length === villageData?.length) {
      setState(prevState => ({ ...prevState, selected_village_ids: villageData }));
    } else {
      setState(prevState => ({ ...prevState, selected_village_ids: selectedOption.length ? [selectedOption[selectedOption.length - 1]] : [] }));
    }
  };

  const handleMultiselectGroupchange = (selectedOptions) => {
    if (enableSelectAll && selectedOptions?.length === groupData?.length) {
      setState(prevState => ({ ...prevState, selected_group_ids: groupData }));
    } else {
      setState(prevState => ({ ...prevState, selected_group_ids: selectedOptions.length ? [selectedOptions[selectedOptions.length - 1]] : [] }));
    }
  };

  const handleRadioChange = (e) => {
    const selectedValue = parseInt(e.target.value);

    setState(prevState => ({
      ...prevState,
      year: years[0].value ?? "1",
      selectedLevel: selectedValue,
      selected_group_ids: selectedValue === 1 ? groupData : [],
      selected_village_ids: selectedValue === 2 ? villageData : [],
    }));
  };

  const handleFarmerChange = (selectedOptions) => {
    setState(prevState => ({ ...prevState, selectedFarmers: selectedOptions || [] }));
  };

  const handleView = (row) => {
    setState(prevState => ({ ...prevState, formViewDetails: true, formRowData: row.original }));
  }

  const handleClose = () => setState((prevState) => ({ ...prevState, formViewDetails: false }));

  const handleMultiselectionchange = (name, selectedValues) => {
    setState((prev) => ({
      ...prev,
      [name]: selectedValues || [],
    }));
  };

  const selectConfig = [
    {
      id: 1,
      key: "year",
      label: "Select Year",
      type: "single",
      value: state.year,
      options: years,
      onChange: handleInputChange,
      name: "year",
      alwaysShow: true,
    },
    {
      id: 2,
      key: "groups",
      label: "Groups",
      type: "multi",
      options: groupData || [],
      value: state.selected_group_ids || [],
      name: "selected_group_ids",
    },
    {
      id: 3,
      key: "villages",
      label: "Villages",
      type: "multi",
      options: villageData || [],
      value: state.selected_village_ids || [],
      name: "selected_village_ids",
    },
    {
      id: 4,
      key: "Farmers",
      label: "Select Farmers",
      type: "multi",
      value: state.selectedFarmers,
      options: state.farmerFilterData?.map((item) => ({
        value: item.id,
        label: `${item.farmer_name} (${item.relative_name})`
      })),
      name: "selectedFarmers",
      alwaysShow: true,
    },
  ];

  const showKey =
    user.user_level_id !== 1 && user.user_level_id !== 2
      ? user.level_id === 1
        ? "villages"
        : "groups"
      : state.selectedLevel === 1
        ? "groups"
        : state.selectedLevel === 2
          ? "villages"
          : null;

  const precautionsDisplayData = state.safety_precautions_arr
    .map((selected) => {
      const selectedId = selected.value ?? selected; // supports both formats
      return cottonData.harmLessOptions.find(
        (opt) => opt.id === selectedId
      );
    })
    .filter(Boolean)
    .map((item) => ({
      label: "Precautions",
      value: item.label || item.name,
      type: "input",
    }));

  console.log("tester", state.form_option_13th_rows);

  return (
    <>
      <Divider sx={{ bgcolor: '#f5f1f1ff' }} />

      <Box mt={1}>
        <Card elevation={6}>
          <CardContent>
            <Box sx={{ backgroundColor: "#fff", p: 0.5 }}>
              {
                (user.user_level_id === 1 || user.user_level_id === 2) && (
                  <FormControl>
                    <RadioGroup
                      row
                      name="radioOption"
                      value={state.selectedLevel}
                      onChange={handleRadioChange}
                    >
                      {levelOptions.length > 0 ? (
                        levelOptions.map((item) => (
                          <FormControlLabel
                            key={item.value}
                            value={item.value}
                            control={<Radio color="success" />}
                            label={item.label}
                            sx={{ mr: 3 }}
                          />
                        ))
                      ) : (
                        <Box sx={{ fontSize: 14 }}>Level Are Not Found</Box>
                      )}
                    </RadioGroup>
                  </FormControl>
                )
              }
            </Box>

            <Divider sx={{ bgcolor: '#f5f1f1ff' }} />

            <Box sx={{ p: 2 }}>
              <Grid container spacing={1}>
                {selectConfig
                  .filter(
                    (item) => item.alwaysShow || item.key === showKey
                  )
                  .map((item) => (
                    <Grid item size={{ xs: 12, md: 3 }} key={item.id}>
                      {item.type === "single" ? (
                        <SingleSelect
                          name={item.name}
                          label={item.label}
                          options={item.options}
                          value={item.value}
                          onChange={item.onChange}
                        />
                      ) : (
                        <MultiSelectWithAll
                          name={item.name}
                          label={item.label}
                          options={item.options}
                          value={state[item.name] || []}
                          onChange={handleMultiselectionchange}
                        />
                      )}
                    </Grid>
                  ))}
              </Grid>
            </Box>

            <Grid container spacing={1}>
              <Grid item size={{ xs: 12, md: 12 }}>
                <MaterialReactTableWithSearch
                  data={state.getFilterData}
                  columns={fieldBookColumns}
                  enableRowActions={rowActions}
                  renderRowActions={renderRowActions}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>




      {
        state.formViewDetails && (
          <Dialog
            open={state.formViewDetails}
            onClose={handleClose}
            TransitionComponent={Transition}
            fullWidth
            maxWidth="lg"
            keepMounted
            PaperProps={{
              sx: {
                borderRadius: 3,
                backgroundColor: '#fdfdfd',
                boxShadow: 6,
                mt: 4,
                alignSelf: 'flex-start',
              },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                color: " #FFFFFF",
                background: "linear-gradient(90deg, #1B5E20, #4CAF50)",
                boxShadow: "0px 3px 10px rgba(0,0,0,0.3)",
                color: '#fff',
                px: 3,
                py: 1,
                borderTopLeftRadius: 12,
                borderTopRightRadius: 12,
              }}
            >
              <DialogTitle sx={{ m: 0, p: 0, fontSize: '1.2rem', textTransform: "uppercase", fontWeight: "bold" }}>FieldBook Details</DialogTitle>

              <IconButton onClick={() => handleClose()} sx={{ color: '#fff' }}>
                <CloseIcon />
              </IconButton>
            </Box>


            <DialogContent dividers>
              <Grid container spacing={1}>
                {
                  [{ label: "Year", value: state.selectYear }, { label: "Farmer", value: state.farmer }].map((item, index) => (
                    <Grid item size={{ xs: 12, md: 3 }}>
                      <TextField label={item.label} value={item.value} size="small" fullWidth disabled InputLabelProps={{
                        sx: {
                          color: "#000",
                          "&.Mui-disabled": {
                            color: "#000", // keep label red when disabled
                          },
                        },
                      }}
                        sx={{
                          "& .MuiInputBase-input": {
                            color: "#000",        // value text color
                          },
                          "& .Mui-disabled .MuiInputBase-input": {
                            WebkitTextFillColor: "#000",   // important for disabled
                          },
                          // background for disabled
                          "& .MuiOutlinedInput-root.Mui-disabled": {
                            backgroundColor: "#e5e5e5",      // change to what you want
                          },
                          "& .MuiInputLabel-root": {
                            color: "#000",
                            fontWeight: 700, // thick black
                          },
                        }} />
                    </Grid>
                  ))
                }
              </Grid>


              <Grid container spacing={1}>
                {[
                  {
                    header: "Land Information :",
                    data: state.land_details_arr.map((landDetail) => [
                      { label: "Soil Type", value: cottonData.getSoilType.find((option) => option.label === landDetail.soil_type)?.label || "-", type: "input", },
                      { label: "Soil Testing", value: landDetail.soil_test, type: "radio", },
                      { label: "Total Land Holding", value: landDetail.total_land || "-", type: "input", },
                      { label: "BCI Cotton Land Holding", value: landDetail.BCI_land || "-", type: "input", },
                    ]),
                  },
                  {
                    header: "Water Management :",
                    data: state.water_manage_arr.map((landDetail) => [
                      { label: "Irrigation Facility", value: cottonData.irrigation_Facility.find(option => option.label === state.water_manage_arr[0].irrigation_facility)?.label || "", type: "input", },
                      { label: "Source Irrigation", value: cottonData.source_irrigation.find(option => option.label === state.water_manage_arr[0].source_irrigation)?.label || "", type: "input", },
                      { label: "Irrigating / hr", value: landDetail.irrigating_hr || "-", type: "input", },
                      { label: "Irrigation L/cm", value: landDetail.irrigation_cm || "-", type: "input", },
                      { label: "Labour Cost", value: landDetail.labour_cost || "-", type: "input", },
                      { label: "Fuel Cost", value: landDetail.fuel_cost || "-", type: "input", },
                      { label: "Elec. Cost", value: landDetail.ele_cost || "-", type: "input", },
                      { label: "Total. Cost", value: landDetail.total_cost || "-", type: "input", },
                    ],
                    ),
                    footer: true,
                    footer_value: state.water_manage_arr.reduce((sum, item) => sum + parseFloat(item.total_cost || 0), 0)
                  },
                  {
                    header: "Details of InterCrop :",
                    data: state.crop_details_arr.map((landDetail) => [
                      { label: "Type of Inter Crop", value: cottonData.inter_crop.find(option => option.label === state.crop_details_arr[0].inter_crop)?.label || "", type: "input", },
                      { label: "Ratio of inter crop", value: landDetail.ratio_inter_crop || "-", type: "input", },
                      { label: "Seed Cost", value: landDetail.seed_cost || "-", type: "input", },
                      { label: "Labour Cost", value: landDetail.labour_cost || "-", type: "input", },
                      { label: "Other Cost", value: landDetail.other_cost || "-", type: "input", },
                      { label: "Total Cost", value: landDetail.total_cost || "-", type: "input", },
                    ],
                    ),
                    footer: true,
                    footer_value: state.crop_details_arr.reduce((sum, item) => sum + parseFloat(item.total_cost || 0), 0)
                  },
                  {
                    header: "Land Preparation :",
                    data: state.form_option_5th_rows.map((landDetail) => [
                      { label: "Type Of work", value: landDetail.type_work || "-", type: "input", },
                      { label: "Equipment Cost", value: landDetail.equpment_cost || "-", type: "input", },
                      // { label: "Fuel (Ltrs)", value: landDetail.fuel_ltrs || "-", type: "input", },
                      // { label: "Fuel cost", value: landDetail.fuel_cost || "-", type: "input", },
                      { label: "Labour Cost", value: landDetail.labour_cost || "-", type: "input", },
                      { label: "Total Cost", value: landDetail.total_cost || "-", type: "input", },
                    ],
                    ),
                    footer: true,
                    footer_value: state.form_option_5th_rows.reduce((sum, item) => sum + parseFloat(item.total_cost || 0), 0)
                  },
                  {
                    header: "Details of cotton seeds :",
                    data: state.form_option_6th_rows.map((landDetail) => [
                      { label: "Type of Seed", value: cottonData.seedsType.find(option => option.label === landDetail.types)?.label || "", type: "input", },
                      { label: "Variety", value: landDetail.variety || "-", type: "input", },
                      { label: " No. of packets", value: landDetail.noOfpackets || "-", type: "input", },
                      { label: "Cost of seed packet", value: landDetail.seedPrice || "-", type: "input", },
                      { label: "Cost of seeds", value: landDetail.totalSeedCost || "-", type: "input", },
                      { label: "Labour Cost", value: landDetail.labourCost || "-", type: "input", },
                      { label: "Total Cost", value: landDetail.total_cost || "-", type: "input", },
                    ],
                    ),
                    footer: true,
                    footer_value: state.form_option_6th_rows.reduce((sum, item) => sum + parseFloat(item.total_cost || 0), 0)
                  },
                  {
                    header: "Gap Filling & Weeding :",
                    data: state.form_option_7th_rows.map((landDetail, index) => [
                      { label: "Type Of Work", value: landDetail.workDetails || "", type: "input", },

                      ...index === 2 ? [{ label: "Name", value: landDetail.name || "-", type: "input", }] :
                        [{ label: "Number of Labours", value: landDetail.noOfLabours || "-", type: "input", }],

                      ...index === 2 ? [{ value: landDetail.quantity, label: "Quantity", type: "input", },] : [
                        { name: "labourCost", value: landDetail.labourCost, label: "Labour Cost", type: "input", },
                      ],

                      ...index === 2 ? [{ value: landDetail.total_cost, label: "Cost", type: "input", }] :
                        [{ value: landDetail.totalLabourChargesInGapFilling, label: "Total Labour Charges", type: "input", },]
                    ],
                    ),
                    footer: true,
                    footer_value: state.form_option_7th_rows.reduce((sum, item) => sum + parseFloat(item.total_cost || 0), 0)
                  },
                  {
                    header: "Organic and Chemical Fertilizers Information :",

                    // form_option_8th_rows: [{ id: "1", typeOf: '', quantity: '', fertilizerCost: '', labourCost: '', totalLabourChargesInOrganicInfo: "", total_cost: '', estatus: 1 }],

                    data: state.form_option_8th_rows.map((landDetail) => [
                      { label: "Fertilizer", value: cottonData.Fertilizers.find(option => option.label === landDetail.typeOf)?.label || "", type: "input", },
                      { label: "Fertilizer cost", value: landDetail.fertilizerCost || "-", type: "input", },
                      { label: "Quantity(kgs/L/Bags)", value: landDetail.quantity || "-", type: "input", },
                      { label: "Total Fertilizer Cost", value: landDetail.totalLabourChargesInOrganicInfo || "-", type: "input", },
                      { label: "Labour cost", value: landDetail.labourCost || "-", type: "input", },
                    ],
                    ),
                    footer: true,
                    footer_value: state.form_option_8th_rows.reduce((sum, item) => sum + parseFloat(item.total_cost || 0), 0)
                  },
                  {
                    header: "Details of Usage of HHP's and Cocktails :",
                    data: state.form_option_13th_rows.map((landDetail) => [
                      { label: "Are you using HHP's", value: landDetail.usingHHP, type: "radio", },

                      ...landDetail.usingHHP !== true ? [] : [{ label: "HHP Name", value: cottonData.HHP_Names.find(option => option.label === state.form_option_13th_rows[0].HHP_name)?.label || "", type: "input", },
                      ],
                      ...landDetail.usingHHP === true ? [{ label: "Cost", value: landDetail.hhp_cost, type: "input", }] : [],

                      { label: "Quanity Kg / L", value: landDetail.HHP_quantity || "-", type: "input", },
                      { label: "Are you using cocktails", value: landDetail.usingCocktails || "-", type: "radio", },
                      ...state.form_option_13th_rows[0].usingCocktails === true ? [{ label: "Cocktail Name", value: landDetail.cocktailsName || "-", type: "input", }] : [],
                      { label: "Quanity Kg / L", value: landDetail.cock_quantity || "-", type: "input", },
                      ...landDetail.usingCocktails === true ? [{ label: "Cost", value: landDetail.cocktailsCost, type: "input", }] : [],
                      { label: "Do you have awareness on the PAN group - 3 pesticides", value: landDetail.awareness_PAN_Group, type: "radio", },
                    ]),
                    footer: true,
                    footer_value: state.form_option_13th_rows.reduce((sum, item) => sum + parseFloat(item.total_cost || 0), 0)
                  },
                  {
                    header: "Pesticides Information :",
                    data: state.form_option_9th_rows.map((landDetail) => [
                      { label: "Pesticide", value: cottonData.Pesticides.find(option => option.label === landDetail.pesticide_name)?.label || "", type: "input", },
                      { label: "Quantity Kg / L", value: landDetail.quantity || "-", type: "input", },
                      { label: "Cost of pesticide", value: landDetail.costOfPesticide || "-", type: "input", },
                      { label: "Labour cost", value: landDetail.labourCost || "-", type: "input", },
                      { label: "Total Cost", value: landDetail.total_cost || "-", type: "input", },
                    ],
                    ),
                    footer: true,
                    footer_value: state.form_option_9th_rows.reduce((sum, item) => sum + parseFloat(item.total_cost || 0), 0)
                  },
                  {
                    header: "Better management practices :",
                    data: state.form_option_10th_rows.map((landDetail) => [
                      { label: "Particulars or Name of Activity", value: cottonData.Practices.find(option => option.label === landDetail.practices)?.label || "", type: "input", },
                      { label: "Quantity Kg / L", value: landDetail.quantity || "-", type: "input", },
                      { label: "Cost", value: landDetail.cost || "-", type: "input", },
                      { label: "Total Cost", value: landDetail.total_cost || "-", type: "input", },
                    ],
                    ),
                    footer: true,
                    footer_value: state.form_option_10th_rows.reduce((sum, item) => sum + parseFloat(item.total_cost || 0), 0)
                  },
                  {
                    header: "Precautions and safety measures to be followed while spraying :",
                    data: [precautionsDisplayData],
                  },
                  {
                    header: "Cotton Harvesting & Fiber Quality Information :",
                    data: state.form_option_11th_rows.map((landDetail) => [
                      { label: "Number of Labours", value: landDetail?.labour_count || "", type: "input", },
                      { label: "Labour Rate", value: landDetail.labour_rate || "-", type: "input", },
                      { label: "YIELD (in Kg /Qt)", value: landDetail.yield || "-", type: "input", },
                      { label: "Cotton / Color Bags", value: landDetail.cotton_colour_bags || "-", type: "input", },
                      { label: "Greading/Segrigation", value: landDetail.greeding_segrigation || "-", type: "input", },
                      { label: "Total Cost", value: landDetail.total_cost || "-", type: "input", },
                    ],
                    ),
                    footer: true,
                    footer_value: state.form_option_11th_rows.reduce((sum, item) => sum + parseFloat(item.total_cost || 0), 0)
                  },
                  {
                    header: "Cotton Sold information :",
                    data: state.form_option_12th_rows.map((landDetail) => [
                      { label: "Date", value: landDetail?.date || "", type: "input", },
                      { label: "Sold Cotton Place", value: landDetail.sold_cotton || "-", type: "input", },
                      { label: "Name Of the Ginner", value: landDetail.ginner || "-", type: "input", },
                      { label: "Cotton Quantity Kg / qt", value: landDetail.cotton_quantity || "-", type: "input", },
                      { label: "RATE/ Qt", value: landDetail.rate || "-", type: "input", },
                      { label: "Income Cotton", value: landDetail.income_cotton || "-", type: "input", },
                      { label: "Transport Cost", value: landDetail.transport_cost || "-", type: "input", },
                      { label: "Other Cost", value: landDetail.other_cost || "-", type: "input", },
                      { label: "Total Cost", value: landDetail.total_cost || "-", type: "input", },
                    ],
                    ),
                    footer: true,
                    footer_value: state.form_option_12th_rows.reduce((sum, item) => sum + parseFloat(item.total_cost || 0), 0)
                  },
                  {
                    header: "Fuel Details & Fuel used for land preparation :",
                    data: state.form_option_14th_rows.map((landDetail) => [
                      { label: "Liters", value: landDetail.preparation_fuel_liters || "-", type: "input", },
                      { label: "Cost per liters", value: landDetail.preparation_fuel_cost || "-", type: "input", },
                      { label: "Total Cost", value: landDetail.total_preparation_fuel_cost || "-", type: "input", },
                    ],
                    ),
                  },
                  {
                    header: "Fuel Details & Fuel used for Transportation :",
                    data: state.form_option_14th_rows.map((landDetail) => [
                      { label: "Liters", value: landDetail.transportation_fuel_liters || "-", type: "input", },
                      { label: "Cost per liters", value: landDetail.transportation_fuel_cost || "-", type: "input", },
                      { label: "Total Cost", value: landDetail.total_transportation_fuel_cost || "-", type: "input", },
                    ],
                    ),
                  },
                  {
                    header: "Fuel Details & Fuel used for Other operations :",
                    data: state.form_option_14th_rows.map((landDetail) => [
                      { label: "Liters", value: landDetail.operations_fuel_liters || "-", type: "input", },
                      { label: "Cost per liters", value: landDetail.operations_fuel_cost || "-", type: "input", },
                      { label: "Total Cost", value: landDetail.total_operations_fuel_cost || "-", type: "input", },
                    ],
                    ),
                  },
                  {
                    header: "Fuel Details & Overall :",
                    data: state.form_option_14th_rows.map((landDetail) => [
                      { label: "otal Liters", value: landDetail.overallLiters || "-", type: "input", },
                      { label: "Final Cost", value: landDetail.finalCost || "-", type: "input", },
                    ],
                    ),
                    footer: true,
                    footer_value: state.form_option_14th_rows.reduce((sum, item) => sum + parseFloat(item.finalCost || 0), 0)
                  },
                  {
                    header: "Cotton Profit Information :",
                    type: "table",
                    tableData: state.cotton_income_details_arr,
                  },
                  {
                    header: "Awareness on Decent Work :",
                    type: "table-radio",
                  }
                ].map((section, sectionIndex) => (
                  <Box key={sectionIndex} mt={1} width="100%">
                    {/* Header */}
                    <Typography variant="h6" fontWeight="bold" mb={1} mt={1}>
                      {section.header}
                    </Typography>

                    {/* Main array */}

                    {
                      section.type === "table" ? (
                        <TableContainer component={Paper} sx={{
                          maxHeight: "60vh",
                          overflowY: "auto",          // vertical scroll
                          overflowX: { xs: "auto", md: "hidden" }, // horizontal scroll only on mobile
                          WebkitOverflowScrolling: "touch", // smooth mobile scroll
                        }}>
                          <Table size="small" sx={{ border: "1px solid green" }}>

                            <TableBody>
                              {state.cotton_income_details_arr.map((row) => (
                                <TableRow key={row.id}>
                                  <TableCell width="5%">
                                    {row.id}.
                                  </TableCell>

                                  <TableCell width="35%">
                                    {row.label}
                                  </TableCell>

                                  <TableCell width="60%">
                                    <TextField
                                      size="small"
                                      fullWidth
                                      value={row.value}
                                      disabled
                                      InputProps={{ readOnly: true }}
                                      sx={{
                                        "& .MuiInputBase-input": {
                                          color: "#000",        // value text color
                                        },
                                        "& .Mui-disabled .MuiInputBase-input": {
                                          WebkitTextFillColor: "#000",   // important for disabled
                                        },
                                        // background for disabled
                                        "& .MuiOutlinedInput-root.Mui-disabled": {
                                          backgroundColor: "#e5e5e5",      // change to what you want
                                        },
                                        "& .MuiInputLabel-root": {
                                          color: "#000",
                                          fontWeight: 700, // thick black
                                        },
                                      }}
                                    />
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      ) : section.type === "table-radio" ? (
                        <TableContainer component={Paper} sx={{
                          boxShadow: 6,
                          overflowY: "auto",          // vertical scroll
                          overflowX: { xs: "auto", md: "hidden" }, // horizontal scroll only on mobile
                          WebkitOverflowScrolling: "touch", // smooth mobile scroll
                        }}>
                          <Table size="small"  >
                            <TableHead sx={{
                              backgroundColor: clientTheme.activeBg,
                            }}>
                              <TableRow>
                                <TableCell>
                                  <Typography fontWeight="bold" sx={{ color: "#fff", p: 1.5, fontWeight: "bold", textTransform: "uppercase" }}>Particulars</Typography>
                                </TableCell>
                                <TableCell align="center" sx={{ color: "#fff", p: 1.5, fontWeight: "bold", textTransform: "uppercase" }}>
                                  <Typography fontWeight="bold">High</Typography>
                                </TableCell>
                                <TableCell align="center" sx={{ color: "#fff", p: 1.5, fontWeight: "bold", textTransform: "uppercase" }}>
                                  <Typography fontWeight="bold">Medium</Typography>
                                </TableCell>
                                <TableCell align="center" sx={{ color: "#fff", p: 1.5, fontWeight: "bold", textTransform: "uppercase" }}>
                                  <Typography fontWeight="bold">Low</Typography>
                                </TableCell>
                              </TableRow>
                            </TableHead>

                            {/* Table Body */}
                            <TableBody>
                              {state.awareness_childlabour_details_arr.map((item) => (
                                <TableRow key={item.id}>
                                  <TableCell>{item.name}</TableCell>

                                  {["High", "Medium", "Low"].map((level) => (
                                    <TableCell align="center" sx={{ color: "#fff", p: 1.5, fontWeight: "bold", textTransform: "uppercase" }} key={level}>
                                      <Radio
                                        checked={item.value === level}
                                        disabled
                                        value={level}
                                        name={`item-${item.id}`}
                                        sx={{
                                          color: "red", // unchecked color
                                          "&.Mui-checked": {
                                            color: "green", // checked color
                                          },
                                          "&.Mui-disabled": {
                                            color: "red",
                                          },
                                          "&.Mui-disabled.Mui-checked": {
                                            color: "green",
                                          },
                                        }}
                                      />
                                    </TableCell>
                                  ))}
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      ) : (<>
                        {section.data.map((itemGroup, groupIndex) => (
                          <Paper
                            key={groupIndex}
                            elevation={3}
                            sx={{
                              border: "1px solid #e0e0e0",
                              p: 2,
                              borderRadius: 2,
                            }}
                          >
                            <Grid container spacing={2}>
                              {itemGroup.map((item, itemIndex) => (
                                <Grid item size={{ xs: 12, md: 3 }} key={itemIndex}>
                                  {item.type === "input" ? (
                                    <TextField
                                      size="small"
                                      label={item.label}
                                      fullWidth
                                      value={item.value}
                                      disabled
                                      InputProps={{ readOnly: true }}
                                      InputLabelProps={{
                                        sx: {
                                          color: "#000",
                                          "&.Mui-disabled": {
                                            color: "#000", // keep label red when disabled
                                          },
                                        },
                                      }}
                                      sx={{
                                        "& .MuiInputBase-input": {
                                          color: "#000",        // value text color
                                        },
                                        "& .Mui-disabled .MuiInputBase-input": {
                                          WebkitTextFillColor: "#000",   // important for disabled
                                        },
                                        // background for disabled
                                        "& .MuiOutlinedInput-root.Mui-disabled": {
                                          backgroundColor: "#e5e5e5",      // change to what you want
                                        },
                                        "& .MuiInputLabel-root": {
                                          color: "#000",
                                          fontWeight: 700, // thick black
                                        },
                                      }}
                                    />
                                  ) : item.type === "radio" ? (
                                    <Box>
                                      <Typography variant="body2" mb={0.5}>
                                        {item.label}
                                      </Typography>

                                      <RadioGroup
                                        row
                                        value={item.value === "Yes" || item.value === true}
                                      >
                                        <FormControlLabel
                                          value={true}
                                          label="Yes"
                                          sx={{
                                            "& .MuiFormControlLabel-label": {
                                              color: "#000",
                                              fontWeight: "bold",
                                            },
                                            "&.Mui-disabled .MuiFormControlLabel-label": {
                                              color: "#000",
                                              fontWeight: "bold",
                                            },
                                          }}
                                          control={
                                            <Radio
                                              disabled
                                              sx={{
                                                color: "red", // unchecked color
                                                "&.Mui-checked": {
                                                  color: "green", // checked color
                                                },
                                                "&.Mui-disabled": {
                                                  color: "red",
                                                },
                                                "&.Mui-disabled.Mui-checked": {
                                                  color: "green",
                                                },
                                              }}
                                            />
                                          }
                                        />

                                        <FormControlLabel
                                          value={false}
                                          label="No"
                                          sx={{
                                            "& .MuiFormControlLabel-label": {
                                              color: "#000",
                                              fontWeight: "bold",
                                            },
                                            "&.Mui-disabled .MuiFormControlLabel-label": {
                                              color: "#000",
                                              fontWeight: "bold",
                                            },
                                          }}
                                          control={
                                            <Radio
                                              disabled
                                              sx={{
                                                color: "red",
                                                "&.Mui-checked": {
                                                  color: "green",
                                                },
                                                "&.Mui-disabled": {
                                                  color: "red",
                                                },
                                                "&.Mui-disabled.Mui-checked": {
                                                  color: "green",
                                                },
                                              }}
                                            />
                                          }
                                        />
                                      </RadioGroup>
                                    </Box>
                                  ) : null}
                                </Grid>
                              ))}
                            </Grid>
                          </Paper>
                        ))}
                      </>)}


                    {section.footer && (
                      <Paper
                        elevation={3}
                        sx={{
                          borderTop: "1px solid red",
                          border: "1px solid #e0e0e0",
                          p: 1.5,
                          borderRadius: 2,
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Typography>
                          <span style={{ color: "green" }}>Grand Total :</span>  {section.footer_value}
                        </Typography>
                      </Paper>
                    )}

                  </Box>
                ))}
              </Grid>

            </DialogContent>
          </Dialog>
        )
      }
    </>
  )
}
export default FieldBookHistory;